export default __webpack_public_path__ + "a60f31a5e5b0d4bb60ff837a14ebd044.png";